<template>
  <div class="spec-popup-ds-card">
    <OverlayLoad :show="overlayShow"></OverlayLoad>
    <van-popup v-model="popupShow" position="bottom" :style="{ height: 'auto', borderRadius: '16px 16px 0 0' }" safe-area-inset-bottom closeable @click-overlay="handleClose">
      <div class="popup-content">
        <!-- 商品信息 -->
        <div class="product-info">
          <img :src="selectedImg" class="product-img" />
          <div class="product-meta">
            <div class="product-price">
              <span class="price">{{ displayPrice }}</span>
              <span class="unit">点</span>
            </div>
            <div class="product-name">{{ displayName }}</div>
          </div>
        </div>
        <!-- 数量选择 -->
        <div class="quantity-section">
          <div class="label">购买数量</div>
          <van-stepper v-model="payCount" min="1" :max="selectedSpec.limitNum" />
          <span v-if="selectedSpec.limitNum" class="limit-tip">限购{{ selectedSpec.limitNum }}件</span>
        </div>
        <!-- 购买按钮 -->
        <div class="buy-btn-bar">
          <van-button type="danger" block round :disabled="isBuyDisabled" @click="handleBuyNow">{{ buyButtonText }}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import OverlayLoad from "./OverlayLoad.vue";
import {
  getSpecInfo,
  isLogin,
  isNoEmptyArr,
} from "./index.action";
import { Toast } from "vant";
export default {
  components: {
    OverlayLoad,
  },
  props: {
    list: {
      type: Array
    },
    queryForm: {
      // 查询商品信息所需参数
      type: Object,
      default: function () {
        return {
          cardId: "",
          cityCode: "",
          brandId: "",
          productId: ""
        };
      }
    }
  },
  data() {
    return {
      notesText: '', // 备注信息
      buyNowShow: true, // 立即购买按钮显示
      specDataLoad: false, // 规格数据加载锁
      overlayShow: false,
      popupShow: false, // 是否打开展示板
      sendSelectType: 4, //配送类型 默认 无需物流
      shopInfo: {}, // 店铺信息
      isDistribution: null,
      selectedSpec: {}, // 当前选择的规格信息
      specList: [], // 规格信息数组
      payCount: 1, // 购买数量
      target: null,
      validate_delivery_dates: [],//商家配送数据，计算运费使用
      showAddressBar: 0,// 是否显示结算页面的上方地址栏. 快递商品可以显示,蛋糕类不支持快递的不显示
    };
  },
  computed: {
    selectedImg() {
      // 兼容多种图片字段
      return (
        this.selectedSpec.img ||
        this.selectedSpec.coverImage ||
        this.selectedSpec.bannerUrl ||
        (this.list && this.list[0] && (this.list[0].img || this.list[0].coverImage || this.list[0].bannerUrl)) ||
        ''
      );
    },
    displayPrice() {
      // 兼容多种价格字段
      return (
        this.selectedSpec.showPrice
      );
    },
    displayName() {
      return (
        this.selectedSpec.productName + (this.selectedSpec.specifications || '')
      );
    },
    isBuyDisabled() {
      const status = Number(this.selectedSpec.status);
      return status === 3 || status === 2; // 3: 补货中, 2: 已下架
    },
    buyButtonText() {
      const status = Number(this.selectedSpec.status);
      if (status === 3) {
        return '补货中';
      } else if (status === 2) {
        return '已下架';
      } else {
        return '立即购买';
      }
    },
  },
  watch: {
    list: {
      handler: function (newVal) {
        if (isNoEmptyArr(newVal)) {
          this.specList = newVal;
          // 如果列表不为空，自动选中第一个作为默认规格
          if (newVal.length > 0) {
            this.selectedSpec = newVal[0];
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    /**
     * 规格选择框打开方法
     */
    async open() {
      this.buyNowShow = true;
      this.overlayShow = true;
      if (isNoEmptyArr(this.list)) {
        setTimeout(() => {
          this.overlayShow = false;
          this.popupShow = true;
        }, 500);
      } else {
        const dataList = await getSpecInfo();
        this.overlayShow = false;
        this.specList = dataList;
        // 如果列表不为空，自动选中第一个作为默认规格
        if (dataList && dataList.length > 0) {
          this.selectedSpec = dataList[0];
        }
        this.popupShow = true;
      }
    },

    handleOverlimit(val) {
      if (this.payCount <= 1) {
        if (val == 'plus') {
          Toast("购买数量最多1件");
        } else
          Toast("购买数量最少1件");
        return
      } else if (this.payCount >= this.selectedSpec.limitNum) {
        Toast(`最大购买数量为${this.payCount}件`);
        return
      }
    },
    /**
     * 立即购买
     */
    handleBuyNow() { // 更名为handleBuyNow，与模板保持一致
      if (Number(this.selectedSpec.status) === 3) {
        Toast('该商品补货中！请选择其他商品')
        return
      }
      if (Number(this.selectedSpec.status) === 2) {
        Toast('该商品已下架！请选择其他商品')
        return
      }
      this.onSubmit("buyNow");
    },
    onSubmit(type) {
      if (!isLogin()) return;
      this.$emit("submit", {
        type: type,
        selectedSpec: {
          ...this.selectedSpec,
          count: this.payCount // 购买数量
        }, // 当前选择的规格
        deliveryData: {
          sendSelectType: this.sendSelectType, // 配送类型
          showAddressBar: this.showAddressBar, // 是否显示结算页面的上方地址栏. 快递商品可以显示,蛋糕类不支持快递的不显示
        },
      });
      this.popupShow = false;
    },
    handleClose() {
      this.popupShow = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.spec-popup-ds-card {
  .popup-content {
    padding: 20px 16px 16px 16px;
    background: #fff;
    border-radius: 16px 16px 0 0;
  }
  .product-info {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    .product-img {
      width: 56px;
      height: 56px;
      border-radius: 8px;
      object-fit: cover;
      margin-right: 14px;
      border: 1px solid #f2f2f2;
    }
    .product-meta {
      flex: 1;
      .product-price {
        font-size: 20px;
        color: #d23b2e;
        font-weight: bold;
        .unit {
          font-size: 14px;
          margin-left: 2px;
        }
      }
      .product-name {
        font-size: 15px;
        color: #333;
        margin-top: 6px;
        font-weight: 500;
      }
    }
  }
  .quantity-section {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .label {
      font-size: 14px;
      color: #666;
      margin-right: 12px;
      min-width: 60px;
    }
    .van-stepper {
      margin-right: 10px;
    }
    .limit-tip {
      color: #fa3534;
      font-size: 12px;
      margin-left: 8px;
    }
  }
  .tip {
    color: #fa3534;
    font-size: 13px;
    margin-bottom: 12px;
    margin-left: 2px;
  }
  .buy-btn-bar {
    margin-top: 18px;
    .van-button {
      background: linear-gradient(90deg, #ff6034 0%, #ee0a24 100%);
      border: none;
      font-size: 16px;
      font-weight: 600;
      height: 44px;
    }
  }
}
</style>
